<template>
  <global-modal :active="dialog.isActive" @toggleActive="toggleActive">
    <!-- Header -->
    <section class="text-xl font-medium" slot="header">Pengiriman Surat Keluar</section>
    <!-- Body -->
    <section class="p-5">
      <!-- Form -->
      <form>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <div>
              <!-- User Sender -->
              <label>Pilih pengirim surat manual</label>
              <vs-select :options="listPengguna" v-model="selectedSender"/>
              <!-- By Email -->
              <vs-checkbox 
                v-if="listEmailReceiver.length != 0"
                class="pt-4" 
                v-model="sendByEmail"
              >
                Kirim surat melalui email 
              </vs-checkbox>
            </div>
          </div>
        </div>
      </form>
    </section>

    <!-- Footer -->
    <section class="p-4 flex justify-end" slot="footer">
      <div>
        <vs-button
          class="mr-2"
          color="primary"
          type="filled"
          :disabled="!isFormValid()"
          @click="handleOnSubmit"
        >
          Simpan Data
        </vs-button>
        <vs-button color="danger" type="border" @click="toggleActive(false)">
          Batal
        </vs-button>
      </div>
    </section>
  </global-modal>
</template>

<script>
import VsSelect from "vue-select";
import QuillEditor from "./QuillEditor";
import {ALL as ALL_PENGGUNA} from "@/query/pengguna";
import {UPDATE_SURAT_KELUAR} from "@/query/surat-keluar";
import { store as storeNotification } from "@/firebase/notification";

export default {
  components: {
    QuillEditor,
    VsSelect
  },
  props: {
    surat: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      dialog: {
        isActive: false
      },
      formValues: {
        pengirim_id: null,
        status_kirim_manual: null,
        status_kirim_email: null,
      },
      selectedSender: null,
      sendByEmail: false,
      listPengguna: []
    };
  },
  apollo: {
    listPengguna: {
      query: ALL_PENGGUNA,
      update: data => {
        const list = data.pengguna.data.map(item => {
          return {value: item.id, label: item.nama};
        });
        return list;
      },
      variables() {
        return {
          perPage: 10000
        };
      },
      fetchPolicy: "cache-and-network"
    }
  },
  computed:{
    listEmailReceiver(){
      if(this.surat.tujuan){
        const listEmailReceiver = this.surat.tujuan.filter(item => {
          return item.email != null;
        });
        return listEmailReceiver;
      }
      else{
        return [];
      }
    }
  },
  watch: {
    selectedSender: {
      handler(){
        if(this.selectedSender.value != null){
          this.formValues.pengirim_id = this.selectedSender.value;
          this.formValues.status_kirim_manual = 'pending';
        }
      }
    },
    sendByEmail: {
      handler(){
        this.sendByEmail 
          ? this.formValues.status_kirim_email = 'pending' 
          : this.formValues.status_kirim_email = null;
      }
    }
  },
  methods: {
    toggleActive(isActive) {
      this.dialog.isActive = isActive;
    },
    isFormValid() {
      const form = this.formValues;
      return form.pengirim_id;
    },
    handleOnSubmit(){
      try{
        this.storeManualSender();
        if(this.sendByEmail){
          this.sendSuratByEmail();
        }
      }
      catch(error){
        this.$vs.notify({
          title: "Oopss, terjadi kesalahan saat update.",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x",
          position: "top-right"
        });
      }
    },
    storeManualSender(){
      this.$apollo.mutate({
        mutation: UPDATE_SURAT_KELUAR,
        variables: {
          id: this.surat.surat_keluar.id,
          input: {
            ...this.formValues
          }
        }
      })
      .then(() => {
        this.$vs.notify({
          title: 'Berhasil menentukan pengirim surat.',
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
          position : "top-right"
        });
        this.storeNotification();
        this.toggleActive(false);
        this.$emit('submitCallback');
      })
      .catch((error) => {
        console.error(error);
        this.$vs.notify({
          title: "Oopss, terjadi kesalahan saat menyimpan pengirim.",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x",
          position: "top-right"
        });
      })
    },
    async sendSuratByEmail(){
      await console.log('send surat by email with api');
    },
    async storeNotification(){
      let data = {
        except_login_id : this.$sanctum.getUser().login_id,
        pengguna_id : this.formValues.pengirim_id,
        pengguna_list : null,
        judul : 'Notifikasi Surat',
        konten : `Terdapat surat ${this.surat.index} yang harus anda kirim secara manual.`,
        halaman : 'surat-keluar-detail',
        notifikasiable_id : this.surat.id,
        notifikasiable_uuid : this.surat.uuid,
        ikon : 'MailIcon'
      }
      await storeNotification(data);
    }
  }
};
</script>
